import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import Storage from '@/utils/storage'
import { Foundation } from '../../ui-utils'
import { domain } from '../../ui-domain'
import store from '@/store'
import https from 'https'
import md5 from 'js-md5'
import checkToken from '@/utils/checkToken'
import { api } from '../../ui-domain'
const qs = require('qs')
axios.defaults.withCredentials = true
// 创建axios实例
const service = axios.create({
  baseURL: api.base, // 基础api
  timeout: 60000, // 请求超时时间
  httpsAgent: new https.Agent({
    rejectUnauthorized: false
  }),
  // xhrFields: {
  //   withCredentials: true
  // },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

// request拦截器
service.interceptors.request.use(config => {
  if(config.isDownload){
    window.open(config.url)
    return
  }
  if (/tree|contract\/info\/contract-num|stock\/stat\/info\/list|\/activity\/info\/pdf\/export|activity\/info\/keywords|stock\/stat\/info\/export|v1\/fin\/appointments|\/info\/data\/collect\/check|contract\/invoice\/info\/operate\/lag/.test(config.url)) {
    config.timeout = 120000
  }
  if (/stock-merchants/.test(config.url)) {
    config.timeout = 300000
  }
  if (/coze/.test(config.url)) {
    config.timeout = 30000000
  }
  if (config.isJson) {
    config.headers = {
      ...config.header,
      'Content-Type': 'application/json'
    }
  }
  // Do something before request is sent
  /** 配置全屏加载 */
  if (config && config.loading && config.loading !== false) {
    const { loading } = config
    const is_num = typeof (config.loading) === 'number'
    if (is_num) config.loading_num = true
    // 为API请求缓存做准备处理
    // config.loading = () => {
    //   return Loading.service({
    //     lock: true,
    //     background: `rgba(0, 0, 0, ${is_num ? loading : '0.8'})`,
    //     spinner: 'el-icon-loading'
    //   })
    // }
    config.loading = Loading.service({
      lock: true,
      background: `rgba(0, 0, 0, ${is_num ? loading : '0.8'})`,
      spinner: 'el-icon-loading'
    })
  }

  /** 进行参数序列化 */
  if ((config.method === 'put' || config.method === 'post') && config.headers['Content-Type'] !== 'application/json' && config.headers['Content-Type'] !== 'multipart/form-data' && !config.upload) {
    config.data = qs.stringify(config.data, { arrayFormat: 'repeat' })
    console.log('进来了吗????')
  }
  //获取访问Token
  // let accessToken = Storage.getItem('jession_token')
  // console.log(accessToken,'accessToken')
  // if (accessToken) {
  //   config.headers['Cookie'] = document.cookie
  // }
  
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  async response => {

    await closeLoading(response)
    // if(response.data.code !== 200){{
    //   return Vue.prototype.$message.error(response.data.msg)
    // }}
    response.data= response.data.body === undefined ? response.data : response.data.body
    return response.data
  },
  async error => {
    await closeLoading(error)
    const error_response = error.response || {}
    const error_data = error_response.data || {}
    if (error_response.status === 403) {
      if (!Storage.getItem('seller_refresh_token')) return
      store.dispatch('fedLogoutAction')
      window.location.replace(`/login?forward=${location.pathname}`)
      return
    }
    if (error.config && error.config.message !== false) {
      let _message = error.code === 'ECONNABORTED' ? '连接超时，请稍候再试！' : '网络错误，请稍后再试！'
      Vue.prototype.$message.error(error_data.message || _message)
    }
    return Promise.reject(error)
  }
)

/**
 * 关闭全局加载
 * 延迟200毫秒关闭，以免晃眼睛
 * @param target
 */
const closeLoading = (target) => {
  const { loading, loading_num } = target.config
  if (!loading) return true
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      target.config.loading.close()
      resolve()
    }, loading_num ? 0 : 200)
  })
}

export default function request(options) {
  // 如果是请求【刷新token、登录、退出】不需要检查token，直接请求。
  if (/logout|\/login|seller\/members\/logout|\/validator/.test(options.url)) {
    return service(options)
  }
  return new Promise((resolve, reject) => {
    checkToken(options).then(() => {
      service(options).then(resolve).catch(reject)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js